import { render } from "./Order_D.vue?vue&type=template&id=3ad6fb18&scoped=true"
import script from "./Order_D.vue?vue&type=script&lang=js"
export * from "./Order_D.vue?vue&type=script&lang=js"

import "@/assets/css/user/common.css?vue&type=style&index=0&id=3ad6fb18&scoped=true&lang=css"
import "@/assets/css/user/pages/main.css?vue&type=style&index=1&id=3ad6fb18&scoped=true&lang=css"
import "@/assets/css/user/pages/lst-allergy.css?vue&type=style&index=2&id=3ad6fb18&scoped=true&lang=css"
import "@/assets/css/user/dark/common-dark.css?vue&type=style&index=3&id=3ad6fb18&scoped=true&lang=css"
import "@/assets/css/user/dark/main-dark.css?vue&type=style&index=4&id=3ad6fb18&scoped=true&lang=css"
import "@/assets/css/user/dark/lst-allergy-dark.css?vue&type=style&index=5&id=3ad6fb18&scoped=true&lang=css"
import "@/assets/css/user/dark/main-d-dark.css?vue&type=style&index=6&id=3ad6fb18&scoped=true&lang=css"
import "@/assets/css/user/pages/admin.css?vue&type=style&index=7&id=3ad6fb18&scoped=true&lang=css"
import "@/assets/css/user/pages/main-d.css?vue&type=style&index=8&id=3ad6fb18&scoped=true&lang=css"
import "@/assets/css/user/pages/table.css?vue&type=style&index=9&id=3ad6fb18&scoped=true&lang=css"
import "./Order_D.vue?vue&type=style&index=10&id=3ad6fb18&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shcho\\Desktop\\home\\git\\test\\cloudpos.kiosk\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ad6fb18"]])

export default __exports__